export const BreadcrumbChevron = () => (
  <svg
    height='7.414'
    viewBox='0 0 4.414 7.414'
    width='4.414'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g transform='translate(3.707 0.707) rotate(90)'>
      <line
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1'
        transform='translate(3 0)'
        x2='3'
        y2='3'
      />
      <line
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1'
        transform='translate(0 0)'
        x1='3'
        y2='3'
      />
    </g>
  </svg>
);
